import { SET_MESSAGE, CLEAR_MESSAGE, EDIT_PROFILE_SUCCESS, FORGOT_PASSWORD_SUCCESS, CHANGE_PASSWORD_SUCCESS, CONFIRM_EMAIL_SUCCESS, FORGOT_PASSWORD_FAIL } from "../actions/types";

const initialState = { message: "" };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { message: payload };

    case CLEAR_MESSAGE:
      return { message: "" };

    case EDIT_PROFILE_SUCCESS:
      return { message: payload };

    case FORGOT_PASSWORD_SUCCESS:
      return { message: payload };

    case FORGOT_PASSWORD_FAIL:
      return { message: payload };

    case CHANGE_PASSWORD_SUCCESS:
      return { message: payload };

    case CONFIRM_EMAIL_SUCCESS:
      return { message: payload };

    default:
      return state;
  }
}
